module.exports = __webpack_public_path__ + "img/cross.eb03b948.png";